import React from "react";
import styled from "styled-components";
import CareersFold1 from "../components/Careers/CareersFold1";
import CareersOpenPosition from "../components/Careers/CareersOpenPosition";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const JobsPage = () => {
  return (
    <>
      <Helmet>
        <title>Careers at appssemble | Join Our Remote Team</title>
        <meta
          name="description"
          content="We hire for passion and talent, not resumes. Join appssemble to build meaningful digital products in a remote-first environment. View open positions."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Careers at appssemble | Join Our Remote Team"
        />
        <meta
          property="og:description"
          content="Explore open roles at appssemble. We're looking for skilled, thoughtful people to help us build better software — fast, and with purpose."
        />
        <meta property="og:url" content="https://appssemble.com/jobs" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Careers at appssemble | Join Our Remote Team"
        />
        <meta
          name="twitter:description"
          content="We're hiring Android developers, UX designers, and more. Work remotely, ship real products, and grow with a team that values autonomy and impact."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/jobs" />
      </Helmet>
      <Wrapper>
        <CareersFold1 />
        <CareersOpenPosition />
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default JobsPage;
const Wrapper = styled.div`
  min-height: 100vh;
`;
